import React from 'react'
import Header from 'components/Header/Header'
import { SocialShareWhite } from 'components/SocialShare/SocialShare'
import ContactUs from 'components/ContactUs/ContactUs'
import SketchizeInfo from 'components/SketchizeInfo/SketchizeInfo'
import { DownloadAll } from 'components/Buttons/Buttons'

class HeroSectionTop extends React.Component {
    render() {
        return (
            <section className="hero-section top">
                <div className="ghost-image"></div>
                <Header />
                <div className="hero-content">
                    <div className="inn">
                        <div className="left">
                            <figure className="hero-img">
                                <img src={require('assets/images/hero-image-01.svg')} alt="Sketchize: Free Wireframing Sketch Sheets" />
                            </figure>
                        </div>
                        <div className="right">
                            <div className="text-block">
                                <h2 className="title">{this.props.title}</h2>
                                <p className="description">{this.props.description}</p>

                                <SketchizeInfo />

                                <a id="buymeacoffee" href="https://www.patreon.com/bePatron?u=10958606" className="buymeacoffee" target="_blank" rel="noopener noreferrer">
                                    <img src={require('assets/images/buy-me-a-coffee-button.svg')} alt="If you like the content buy me a coffee." />
                                </a>

                            </div>{/* .text-block */}
                        </div>{/* .right */}
                    </div>{/* .inn */}
                </div>{/* .hero-content */}

                <div className="hero-bottom">
                    <ContactUs />
                    <div className="scroll-down-btn">
                        <span className="sketch-scroll-down"><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
                    </div>
                    <div className="scroll-down-btn-mobile">
                        <div className="text">SCROLL DOWN</div>
                        <span className="sketch-arrow-down"></span>
                    </div>
                    <SocialShareWhite />
                </div>{/* .hero-bottom */}
            </section>
        )
    }
}

class HeroSectionDetail extends React.Component {
    render() {
        return (
            <section className="hero-section top">
                <div className="ghost-image"></div>
                <Header />
                <div className="hero-content">
                    <div className="inn">
                        <div className="left">
                        </div>
                        <div className="right">
                            <div className="text-block">
                                <h2 className="title">{this.props.title}</h2>
                                <p className="description">{this.props.description}</p>
                            </div>{/* .text-block */}
                        </div>{/* .right */}
                    </div>{/* .inn */}
                </div>{/* .hero-content */}
            </section>
        )
    }
}

class HeroSectionBottom extends React.Component {
    render() {
        return (
            <section className="hero-section bottom">
                <div className="ghost-image" />
                <div className="hero-content">
                    <div className="inn">
                        <div className="left">
                            <figure className="hero-img">
                                <img src={require('assets/images/hero-image-02.svg')} alt="Sketchize: Free Sketch Sheets" />
                            </figure>
                        </div>
                        <div className="right">
                            <div className="text-block">
                                <h2 className="title">{this.props.title}</h2>
                                <p className="description">{this.props.description}</p>
                                <p className="description">All the sketch sheets are relevant for the standard A3/A4 paper sizes.</p>
                                <DownloadAll link={"https://github.com/sefishprimate/Sketchize/raw/master/tools/zipped-files/sketchize-all.zip"} content="DOWNLOAD ALL" />
                                <ContactUs />
                            </div>{/* .text-block */}
                        </div>{/* .right */}
                    </div>{/* .inn */}
                </div>{/* .hero-content */}
            </section>
        )
    }
}

export { HeroSectionTop, HeroSectionDetail, HeroSectionBottom }



// WEBPACK FOOTER //
// ./src/components/HeroSections/HeroSections.js